import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  text: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  icon: {
    fontSize: '16px',
    marginRight: theme.spacing(1.5),
    color: theme.palette.primary.main,
  },
}));

type SaveButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  customText?: string;
  type?: 'button' | 'reset' | 'submit' | undefined,
  size?: "medium" | "large" | "small" | undefined
};

const SaveButton = ({
  disabled = false,
  loading = false,
  onClick,
  customText,
  type,
  size
}: SaveButtonProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Button
      disableElevation
      color="secondary"
      variant="contained"
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      size={size}
    >
      {!loading && <FontAwesomeIcon icon="check" className={classes.icon} />}

      {loading && <FontAwesomeIcon spin icon="spinner" />}

      {!loading && (
        <Typography variant="body2" className={classes.text}>
          {customText || t('common:save')}
        </Typography>
      )}
    </Button>
  );
};

export default SaveButton;
